import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import type { ApiNotaryMailConfigurationResponse } from '@izimi/api';

import NotaryQueryKeys from './NotaryQueryKeys';

export const notaryQueryKeys = new NotaryQueryKeys('notary');

export const useInvalidatePreferredNotaryCache = () => {
  const queryClient = useQueryClient();

  const invalidatePreferredNotaryCache = useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: notaryQueryKeys.getPreferredNotary(),
      }),
    [queryClient],
  );

  return invalidatePreferredNotaryCache;
};

export const useInvalidateNotaryClaimedVaultsCache = () => {
  const queryClient = useQueryClient();

  const invalidateNotaryClaimedVaultsCache = useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: notaryQueryKeys.getNotaryClaimedVaults({}),
      }),
    [queryClient],
  );

  return invalidateNotaryClaimedVaultsCache;
};

export const useInvalidateNotaryHeirsCache = () => {
  const queryClient = useQueryClient();

  const invalidateNotaryHeirsCache = useCallback(
    (vaultId: string) =>
      queryClient.invalidateQueries({
        queryKey: notaryQueryKeys.getNotaryHeirs({ vaultId }),
      }),
    [queryClient],
  );

  return invalidateNotaryHeirsCache;
};

export const useSetNotaryMailConfigurationCache = () => {
  const queryClient = useQueryClient();

  const setUserMailConfiguration = useCallback(
    (mailConfiguration: ApiNotaryMailConfigurationResponse) =>
      queryClient.setQueryData(notaryQueryKeys.getNotaryMailConfiguration(), mailConfiguration),
    [queryClient],
  );

  return setUserMailConfiguration;
};
